import {inject,Injectable} from '@angular/core';
import {HttpClient,HttpContext} from '@angular/common/http';
import {LoginRequestDto} from './dto/login-request.dto';
import {BehaviorSubject,catchError,firstValueFrom,Observable,switchMap,tap,throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {CookieService} from 'ngx-cookie-service';
import {UserResponseDto} from './dto/user-response.dto';
import {DOCUMENT} from '@angular/common';
import {SKIP_REQUEST} from './authentication.interceptor';

@Injectable({
	providedIn:'root'
})
export class AuthenticationService{
	private readonly document=inject(DOCUMENT);
	private httpClient=inject(HttpClient);
	private cookieService=inject(CookieService);
	readonly userSource=new BehaviorSubject<UserResponseDto|null|undefined>(undefined);
	user=this.userSource.asObservable();
	
	constructor(){
		firstValueFrom(this.getUser()).then().catch((error)=>console.error(error.message));
	}
	
	getUser():Observable<UserResponseDto>{
		return this.httpClient.get<UserResponseDto>(`${environment.apiServer.url}/api/authentication/user`,{withCredentials:true})
		.pipe(
			tap((response)=>{
				this.userSource.next(response);
			}),
			catchError((error)=>{
				this.userSource.next(null);
				return throwError(()=>error);
			})
		);
	}
	
	// A 401 from login means wrong credentials, not an expired session, so the request skips the
	// interceptor that would refresh the session and send it again.
	login(data:LoginRequestDto):Observable<UserResponseDto>{
		return this.httpClient.post<UserResponseDto>(`${environment.apiServer.url}/api/authentication/login`,data,{withCredentials:true,context:new HttpContext().set(SKIP_REQUEST,true)})
		.pipe(
			switchMap(this.getUser.bind(this))
		);
	}
	
	logout():void{
		this.httpClient.post(`${environment.apiServer.url}/api/authentication/logout`,{},{withCredentials:true})
		.pipe(
			tap(()=>{
				this.document.location.reload();
			}),
			catchError((error)=>{
				setTimeout(()=>this.document.location.reload(),200);
				return throwError(()=>error);
			})
		)
		.subscribe({next:console.log,error:console.error});
	}
}
